<template>
    <div id="app" v-cloak>
        <transition name="router-fade" mode="out-in">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
        </transition>
        <transition name="router-fade" mode="out-in">
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </transition>
        <!-- <router-view></router-view> -->
    </div>
</template>
<!--<style src="@/assets/css/mobile.scss"></style>-->
<style>
    #app {
        height: 100%;
        font-size: 14px;
    }
    .gray-back {
        /*height: 100%;*/
        background: #f8f8f8;
    }
    .gray{
        color: #666 !important;
    }
    .green{
        color: #42BD56 !important;
    }
    .tiny-btn-1{
        padding: 0 10px;
        line-height:20px;
        color: #333;
        font-size: 12px;
        text-align: center;
        height:20px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:20px;
    }
    .tiny-btn-0{
        padding: 0 10px;
        line-height:20px;
        color: #000;
        font-size: 12px;
        text-align: center;
        height:20px;
        background: #fff;
        border: 1px solid #000;
        border-radius:20px;
    }
    .poptitle{
        font-size: 0.32rem;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        border-bottom: 1px #eee solid;
    }
    .pay-item-content input::-webkit-input-placeholder { /* WebKit browsers */
        color:    #999;
    }
    .pay-item-content input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color:    #999;
    }
    .pay-item-content input::-moz-placeholder { /* Mozilla Firefox 19+ */
        color:    #999;
    }
    .pay-item-content input:-ms-input-placeholder { /* Internet Explorer 10+ */
        color:    #999;
    }


    .badge{
        display: inline-block;
        box-sizing: border-box;
        min-width: 16px;
        padding: 0 3px;
        color: #fff;
        font-weight: 500;
        font-size: 12px;
        font-family: -apple-system-font, Helvetica Neue, Arial, sans-serif;
        line-height: 1.2;
        height: 16px;
        text-align: center;
        background-color: #ee0a24;
        border: 1px solid #fff;
        border-radius: 999px;
    }

    .question-icon{margin : 0.1rem 0.1rem 0 0 }
    .van-cell-group{margin: 0 .2rem  .2rem .2rem !important; border-radius:0.2rem !important}
    .van-cell-group .van-cell:first-child{ background-color: #ffffff00}
    .van-cell-group .van-cell:last-child{ background-color: #ffffff00}
    .van-cell-group::after{ border: none}



    .operate-desc-left {
        color: #999;
        text-align: left;
        margin: 0.1rem 0 0.3rem 0.3rem;
        border-bottom: 1px solid #ebedf0;
        padding-bottom: 0.2rem;
    }
    .operate-desc {
        color: #999;
        text-align: right;
        margin: 0.1rem 0.3rem 0.1rem 0;
    }

    .operate-desc span {
        text-decoration: line-through;
    }

    .van-form .row {
        padding: 10px 15px;
        display: flex;
    }

    .van-form .row-small {
        padding: 10px 15px;
        display: flex;
    }

    .on-show-one{
        display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 1;
overflow: hidden
    }
    .on-show-two{
        display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
overflow: hidden
    }



</style>
<script>
    export default {
        name: 'app',
    }
</script>


// WEBPACK FOOTER //
// App.vue?d16f1334